module.exports = __webpack_public_path__ + "static/media/clean-ginssen-icon-01.d655df28.png";